import Layout from "../components/layout/Layout";
import "../views/LandingPage.css";
function LandingPage() {
  return (
    <Layout>
      <div className="landing-page-container">
        <h1>Chatbox Landing page</h1>
      </div>
    </Layout>
  );
}

export default LandingPage;
